import Bowser from 'bowser';
export class Capabilities {
    constructor(userAgent) {
        Object.defineProperty(this, "browserParser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (!userAgent) {
            userAgent =
                typeof window !== 'undefined'
                    ? window.navigator.userAgent
                    : 'PrintuRenderer/1.0';
        }
        this.browserParser = Bowser.getParser(userAgent);
    }
    get agent() {
        return this.browserParser.getUA();
    }
    get isDesktop() {
        return this.browserParser.getPlatformType() === 'desktop';
    }
    get isIe() {
        return this.browserParser.getBrowserName() === 'Internet Explorer';
    }
    get isChrome() {
        return this.browserParser.getBrowserName() === 'Chrome';
    }
    get isEdge() {
        return this.browserParser.getBrowserName() === 'Microsoft Edge';
    }
    get edgeVersionNumber() {
        if (this.isEdge) {
            return parseInt(this.browserParser.getBrowserVersion(), 10);
        }
        return false;
    }
    get isIPad() {
        return this.isIPadOnIOS || this.isIPadOnIPadOS;
    }
    get isAndroid() {
        return this.browserParser.getOSName() === 'Android';
    }
    get androidVersionNumber() {
        return this.browserParser.getOSName() !== 'Android'
            ? 0
            : parseInt(this.browserParser.getOSVersion(), 10);
    }
    get isFirefox() {
        return this.browserParser.getBrowserName() === 'Firefox';
    }
    get isMac() {
        return this.browserParser.getOSName() === 'macOS';
    }
    get isWin() {
        return this.browserParser.getOSName() === 'Windows';
    }
    get isSafari() {
        return this.browserParser.getBrowserName() === 'Safari';
    }
    get isSafari11() {
        return this.browserParser.satisfies({ safari: '11' }) || !1;
    }
    get isSafari15() {
        return this.browserParser.satisfies({ safari: '15' }) || !1;
    }
    get isMobileDevice() {
        return this.browserParser.getPlatformType() === 'mobile';
    }
    get screenAspectRatio() {
        return window.screen.width / window.screen.height;
    }
    get doesSupportTouch() {
        return this.getDoesSupportTouch();
    }
    get doesSupportFeDropShadow() {
        return !(this.isEdge || this.isIe);
    }
    get isIPadOnIOS() {
        return this.browserParser.getPlatform().model === 'iPad';
    }
    get isIPadOnIPadOS() {
        return (this.browserParser.getPlatform().vendor === 'Apple' &&
            this.isDesktop &&
            this.doesSupportTouch);
    }
    isSafariOlderThan(version) {
        return this.browserParser.satisfies({ safari: '<' + version }) || !1;
    }
    getDoesSupportTouch() {
        return 'ontouchstart' in window;
    }
    getInfo() {
        return this.browserParser.getResult();
    }
}
Object.defineProperty(Capabilities, "shared", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: new Capabilities()
});
